<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      xs12
    >
      <v-card>
        <v-card-title>
          <h3>Turnos disponibles del {{ date | parseDate }}</h3>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="turnosLibres"
          :search="search"
          rows-per-page-text="Turnos por pagina"
          :rows-per-page-items="[5,10,25,{ text: 'Todos', value: -1 }]"
        >
          <template v-slot:items="props">
            <td>{{ props.item.hora }}</td>
            <td>{{ props.item.profesional }}</td>
            <td class="text-xs-left">
              <v-btn
                v-if="!props.item.online"
                icon
                @click="acceptAppointment(props.item)"
              >
                <v-icon>phone_in_talk</v-icon>
              </v-btn>
              <v-btn
                v-if="props.item.online"
                icon
                class="primary"
                @click="acceptAppointment(props.item)"
              >
                <v-icon>check</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import { verificarTurno } from '../../api/appointmentsEndpoints'

export default {
  name: 'FreeAppointmentsTable',
  filters: {
    parseDate (val) {
      moment.locale('es')
      return moment(val).format('dddd DD-MM-YYYY').toUpperCase()
    }
  },
  props: {
    turnosLibres: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    },
    date: {
      default: moment().format('DD-MM-YYYY'),
      type: String,
      required: false
    }
  },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Hora', value: 'hora', class: 'small-width' },
        { text: 'Profesional', value: 'profesional' },
        { text: 'Reserva', value: null, class: 'subheading font-weight-bold', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState(['isUserLoggedIn']),
    ...mapGetters(['user', 'getSelectionParams'])
  },
  methods: {
    async acceptAppointment (props) {
      if (!props.online) {
        this.$createAlert({
          message: 'Para solicitar este turno debe comunicarse telefónicamente',
          type: 'warning',
          color: 'black',
          duration: 5000
        })
      } else {
        await this.$store.dispatch('setSelectedAppointment', props)
        if (this.isUserLoggedIn) {
          const patient = {
            pacienteId: this.user.id,
            obraSocial: this.getSelectionParams.selectedCobertura.obraSocial,
            plan: this.getSelectionParams.selectedCobertura.plan,
            prestacion: this.getSelectionParams.selectedPrestacion.prestacion
          }
          const appointmentVerified = await verificarTurno(patient, props.turno)
          if (appointmentVerified.respuesta === 'OK') {
            const appointmentObject = { appointment: props, verification: appointmentVerified.mensaje }
            this.$emit('accept', appointmentObject)
          } else {
            this.$createAlert({
              message: appointmentVerified.mensaje,
              type: 'error',
              duration: 5000
            })
            if (appointmentVerified.respuesta === 'ERRORDATOS') {
              this.$router.replace({ name: 'SettingsView' })
            }
          }
        } else {
          this.$router.replace({ name: 'LoginView' })
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">
  .small-width
    width: 50px

</style>
